module.exports = __webpack_public_path__ + "img/pr-2.e6f79521.png";